import Reveal from '@/pages/zz-review/components/Reveal';

const branches = [
  { name: '1001 宇宙書架', role: '書籍提供地圖' },
  { name: '生命實踐 Portal', role: 'Portal 陪伴實踐' },
  { name: 'AI Angel', role: 'AI 協助整理與導航' },
  { name: 'Evidence 成長紀錄', role: '留下真實生命成長的軌跡' },
  { name: '生命共同體', role: '個體到社群的共構' },
  { name: '文明永續', role: '長程願景與共建' },
];

export default function LivingTreeSection() {
  return (
    <section id="tree" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              Living Tree
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              宇宙生命樹
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3">
              The Whole Architecture
            </p>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <p className="text-center text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto mb-10">
            AUM1001 Matrix 是一棵完整的生命樹。《1001旋轉門》只是目前公開的入口，不是全部。樹上每一根枝幹，都對應生命與文明的一條道路。
          </p>
        </Reveal>

        <Reveal delay={100}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
            {branches.map((branch) => (
              <div
                key={branch.name}
                className="rounded-lg border border-background-200/70 bg-background-50 px-5 py-6"
              >
                <p
                  className="text-base md:text-lg text-foreground-900 font-medium mb-1"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {branch.name}
                </p>
                <p className="text-sm text-foreground-500">{branch.role}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={140}>
          <div className="text-center">
            <p
              className="text-sm md:text-base text-foreground-700 leading-relaxed"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Living Tree is the whole architecture.
            </p>
            <p
              className="text-sm md:text-base text-foreground-500 leading-relaxed mt-1"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Revolving Gate is the current public START HERE.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}